import en from "./en";
import zhCN from "./zh-cn";
export default {
    en,
    zhCN,
};
